import React from 'react';
import { Goal, Milestone, DailyTask } from '../../types/goals';
import { GoalDetails } from "../goals/GoalDetails";
import { GoalWizard } from "../goals/GoalWizard";

interface GoalsModalsProps {
    selectedGoal: Goal | null;
    showWizard: boolean;
    onCloseDetails: () => void;
    onCloseWizard: () => void;
    onGoalCreated?: () => void; // Añadimos esta nueva propiedad
    milestones: Milestone[];
    dailyTasks: DailyTask[];
    toggleTaskCompletion: (taskId: string) => void;
}

const GoalsModals: React.FC<GoalsModalsProps> = ({
    selectedGoal,
    showWizard,
    onCloseDetails,
    onCloseWizard,
    onGoalCreated,
    milestones,
    dailyTasks,
    toggleTaskCompletion
}) => {
    return (
        <>
            {selectedGoal && (
                <GoalDetails
                    key={selectedGoal._id}
                    goal={selectedGoal}
                    milestones={milestones}
                    dailyTasks={dailyTasks}
                    onClose={onCloseDetails}
                    toggleTaskCompletion={toggleTaskCompletion}
                />
            )}

            {showWizard && (
                <GoalWizard
                    onClose={onCloseWizard}
                    onGoalCreated={onGoalCreated}
                />
            )}
        </>
    )
}

export default GoalsModals;